import React from 'react';
import { SERIF, SANS, IITH } from '@/pages/landing/iithBrand';

/** Light in-content page title for FIC screens (avoids a second navy hero). */
export default function LeadershipPageHeader({ title, subtitle, actions, children }) {
  return (
    <div className="mb-5" data-testid="leadership-page-header">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="min-w-0">
          <h1
            className="text-2xl sm:text-[1.75rem] font-semibold text-[#071B34] tracking-tight"
            style={{ fontFamily: SERIF }}
          >
            {title}
          </h1>
          {subtitle ? (
            <p className="text-sm mt-1 max-w-2xl leading-relaxed" style={{ color: IITH.mute, fontFamily: SANS }}>
              {subtitle}
            </p>
          ) : null}
        </div>
        {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
      </div>
      {children ? <div className="mt-4">{children}</div> : null}
    </div>
  );
}
